import 'twin.macro';
import React from 'react';
import _isEmpty from 'lodash-es/isEmpty';
import { SchoolSchoolyearInfo } from '@teetsh/app/src/containers/Search/components/SchoolSchoolyearInfo';
import { useTranslation } from 'react-i18next';

interface Props {
  title: string;
  schoolName?: string;
  schoolyear?: number;
  children?: React.ReactNode;
}

export default function TextWithSchoolOption(props: Props) {
  const { title, schoolyear, schoolName, children } = props;
  const { t } = useTranslation(['common']);
  return (
    <div tw="grid grid-cols-12">
      <div tw="col-span-8">
        {_isEmpty(title) ? t('common:search.seanceWithEmptyTitle') : title}
        {children && <div tw="text-sm text-muted">{children}</div>}
      </div>

      {schoolName && schoolyear && (
        <div tw="col-span-4">
          <SchoolSchoolyearInfo
            schoolName={schoolName}
            schoolyear={schoolyear}
          />
        </div>
      )}
    </div>
  );
}
